import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import {getListAPI} from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import { use } from "react";
import { set } from 'lodash';


export default function TaskSpaceProdFilling() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);
 
  useEffect(() => {
     dispatch(setCompleteTaskButtonEnabled(false));
  },[]);


  const handleRadioChange = (e) => {
    const value = e.target.value
    setConfirmed(value);
    dispatch(setCompleteTaskButtonEnabled(value));
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={4} md={4} sm={4} xs={12}>
              <ProductInfo productId={productObj.id} />
            </Grid>
            <Grid item lg={8} md={8} sm={8} xs={12} sx={{ pt: 2,  }} >
              <Box sx={{ width: '100%',backgroundColor:'white', borderRadius: 2, p: 2 }}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  I confirm that Filling is Complete and Product is ready for Packaging.
                </FormLabel>
                <RadioGroup
                  row
                  value={confirmed}
                  onChange={handleRadioChange} // Call directly, not as arrow function
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio disabled={taskApiResponse && taskApiResponse.status} />}
                    label="Yes"
                    disabled={taskCompleted}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio disabled={taskApiResponse && taskApiResponse.status} />}
                    label="No"
                    disabled={taskCompleted}
                  />
                </RadioGroup>
              </FormControl>
              </Box>
            </Grid>
          </Grid>
      </Grid>
          
    
  );
}